import { render, staticRenderFns } from "./guideTab.vue?vue&type=template&id=a7bc97a8&scoped=true"
import script from "./guideTab.vue?vue&type=script&lang=js"
export * from "./guideTab.vue?vue&type=script&lang=js"
import style0 from "./guideTab.vue?vue&type=style&index=0&id=a7bc97a8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7bc97a8",
  null
  
)

export default component.exports